import { render, staticRenderFns } from "./table-head.vue?vue&type=template&id=735a1c0f"
import script from "./table-head.vue?vue&type=script&lang=js"
export * from "./table-head.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports